var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-labelledby": "search",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 29.1188L22.1755 19.2943C25.8545 14.1175 24.9536 6.98512 20.1027 2.8858C15.2519 -1.21351 8.06917 -0.912485 3.57834 3.57834C-0.912485 8.06917 -1.21351 15.2519 2.8858 20.1027C6.98512 24.9536 14.1175 25.8545 19.2943 22.1755L29.1188 32L32 29.1188ZM12.2288 20.3735C7.73058 20.3735 4.08407 16.727 4.08407 12.2288C4.08407 7.73058 7.73058 4.08407 12.2288 4.08407C16.727 4.08407 20.3735 7.73058 20.3735 12.2288C20.3735 14.3889 19.5154 16.4605 17.9879 17.9879C16.4605 19.5154 14.3889 20.3735 12.2288 20.3735Z",
  fill: "black"
}))));
export default SvgSearch;